/* src/app/modules_v2/contacts/components/contact-detail-tabs/contact-detail-tabs.component.scss */
:host {
  display: block;
}
.cd-panel {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(0, 1.6fr);
  gap: 16px;
}
.cd-panel--single {
  grid-template-columns: minmax(0, 520px);
}
.cd-side {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}
.cd-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.cd-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.cd-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
}
.cd-card__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.cd-card__hint {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.cd-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  min-width: 0;
}
.cd-avatar {
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #fbfee8;
  border: 1px solid #e5f3a0;
  color: #1a1d23;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
}
.cd-profile__main {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.cd-profile__name {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cd-profile__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #6b7280;
}
.cd-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}
.cd-contact__item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: #2f3540;
  min-width: 0;
}
.cd-contact__item mat-icon {
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-top: 1px;
  color: #9ca3af;
}
.cd-contact__item a {
  color: #2f3540;
  text-decoration: none;
  overflow-wrap: anywhere;
}
.cd-contact__item a:hover {
  text-decoration: underline;
}
.cd-contact__item span {
  overflow-wrap: anywhere;
}
.cd-muted {
  color: #9ca3af;
}
.cd-lines {
  display: flex;
  flex-direction: column;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.cd-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.cd-line + .cd-line {
  border-top: 1px solid #eef1f4;
}
.cd-line__value {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  white-space: nowrap;
}
.cd-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.cd-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.cd-kpi--warn {
  background: #fffbeb;
  border: 1px solid #fde68a;
}
.cd-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.cd-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cd-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0 10px;
}
.cd-progress__bar {
  flex: 1;
  height: 8px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
}
.cd-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: #c5d94a;
  transition: width 0.3s ease;
}
.cd-progress__label {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.cd-docs {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cd-doc {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
}
.cd-doc__date {
  color: #6b7280;
  white-space: nowrap;
}
.cd-doc__number {
  color: #2f3540;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cd-doc__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  min-width: 90px;
  text-align: right;
}
.cd-more {
  margin: 8px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.cd-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.cd-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
@media (max-width: 900px) {
  .cd-panel {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .cd-kpis {
    grid-template-columns: 1fr;
  }
  .cd-doc {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .cd-doc__date {
    grid-column: 1/-1;
  }
}
/*# sourceMappingURL=contact-detail-tabs.component.css.map */
